module.exports = __webpack_public_path__ + "img/visa-debito-nacional.ebefdc1a.png";